'use client'

import { useContextElement } from '@/context/Context'

export default function CartLength() {
  const { cartProducts } = useContextElement()
  return <>{cartProducts.reduce((sum, p) => sum + (p.Qty || 1), 0)}</>
}
